import type { ReactNode } from 'react';
import { Heading1, Muted } from '@/components/Typography';

export interface DashboardPageContainerProps {
  headline: string;
  subheading?: string;
  cta?: ReactNode;
  children: ReactNode;
}

export function DashboardPageContainer({
  headline,
  subheading,
  cta,
  children,
}: DashboardPageContainerProps) {
  return (
    <div className="p-6">
      {/* Header Section */}
      <div className="mb-8">
        <div className="mb-6 flex items-center justify-between">
          <Heading1>{headline}</Heading1>
          {cta}
        </div>
        {subheading && <Muted>{subheading}</Muted>}
      </div>

      {/* Main Content */}
      {children}
    </div>
  );
}
